import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TClassificationsApi } from './types';

export const classifications: TClassificationsApi = {
	getJobs: () => {
		return http.post(endpoint.classifications.JOBS).then((response) => response.data);
	},
};
